import React, { useEffect, useRef, useState } from "react";
import CircularLoader from "../../components/Loader/CircularLoader";
import style from "./Cylinders.module.scss";
import { QRCodeCanvas } from "qrcode.react";
import { Button } from "react-bootstrap";
import { MyButton } from "../../Hooks/useButton";

const GenerateCode = (props) => {
  const [batch_no, setBatchNo] = useState();
  const [loading, setLoading] = useState(false);

  function delay(ms) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  const getCode = async () => {
    setLoading(true);
    await delay(2000);
    setBatchNo(props.code);
    setLoading(false);
  };

  useEffect(() => {
    getCode();
  }, []);

  const qrRef = useRef();

  const downloadQRCode = (e) => {
    e.preventDefault();
    let canvas = qrRef.current.querySelector("canvas");
    let image = canvas.toDataURL("image/png");
    let anchor = document.createElement("a");
    anchor.href = image;
    anchor.download = `qr-${batch_no}.png`;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  const qrcode = (
    <QRCodeCanvas
      id='qrCode'
      value={batch_no}
      size={250}
      bgColor={"white"}
      level={"H"}
    />
  );
  return loading ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularLoader />
    </div>
  ) : (
    <div className={style.instruction}>
      <div className={style.qrcode__container}>
        <div ref={qrRef}>{qrcode}</div>
      </div>
      {/* <Button onClick={downloadQRCode} className='w-100 mt-2'>
        {" "}
        Download QR{" "}
      </Button> */}
      <MyButton
        text='Download QR'
        onClick={downloadQRCode}
        btnClass={style.qrBtn}
      />
    </div>
  );
};

export default GenerateCode;
